export {
    makeRequest as makeOwsPrimeRequest,
    makePostRequest,
    makePatchRequest,
    makePutRequest,
    makeGetRequest,
    makeDeleteRequest,
    registerCreateServiceResponseCallback,
    gulpParam,
    owsServerParam,
    owsApiParam,
    HttpMethod,
    PrimeServiceError,
} from './makeServiceRequest';
